import { render, staticRenderFns } from "./TakipEtiketiForm.vue?vue&type=template&id=18c21621"
import script from "./TakipEtiketiForm.vue?vue&type=script&lang=ts"
export * from "./TakipEtiketiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports